
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/articles/the-danger-of-certitude",
      function () {
        return require("private-next-pages/articles/the-danger-of-certitude.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/articles/the-danger-of-certitude"])
      });
    }
  